import { __assign } from "tslib";
import React, { Suspense } from 'react';
import { themes } from '../../ThemeOptions';
import Skeletons from './Skeleton';
var loading = function (ioMode, ioTheme, styleName) {
    return React.createElement(Skeletons, { count: 1, ioMode: ioMode, ioTheme: ioTheme, styleName: styleName });
};
var BootStrapLoading = React.lazy(function () {
    return import('../../bootstrap-components/components/BTLoadingComponent');
});
var bootStrapLoading = function (props) {
    console.log('Hello Loading');
    return (React.createElement(BootStrapLoading, __assign({}, props)));
};
var LoadingComponent = function (props) {
    var componentToDisplay = bootStrapLoading(props);
    return (React.createElement(React.Fragment, null,
        React.createElement(Suspense, { fallback: loading(props.ioMode, props.ioTheme, props.styleName) }, componentToDisplay)));
};
LoadingComponent.defaultProps = {
    styleName: 'primary',
    ioTheme: themes[0],
    ioMode: 'dark'
};
export default LoadingComponent;
//# sourceMappingURL=LoadingComponent.js.map